import styled from "styled-components";

const Wizytowka = styled.div`
  height: 60vh;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url("https://cdn.programadoresbrasil.com.br/wp-content/uploads/2021/04/1_hCepk89R2z0Jp3OyWdvJ8Q-1140x694.jpeg");
  text-align: center;
  background-size: cover;
  text-shadow: 0 0 1vh black;
  color: aliceblue;
  text-shadow: 0 0 1vh #000000;
  & > h1 {
    font-size: 12vh;
  }

  & > p {
    margin-top: 10vh;
    font-size: 4vh;
  }
  @media screen and (max-width: 479px) {
    & > h1 {
      font-size: 9vh;
    }
  }
`;
export default function CallMe() {
  return (
    <Wizytowka>
      <h1>Masz pytanie?</h1>
      <p>
        Zadzwoń pod numer:<br></br>
        +48 536 856 212
      </p>
    </Wizytowka>
  );
}
